import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// 🛡️ RATE LIMITING COMPONENT FOR ADMIN ROUTES
const RateLimitedRoute = ({ children, maxRequests = 10, windowMs = 60000 }) => {
  const [requestCount, setRequestCount] = useState(0);
  const [lastReset, setLastReset] = useState(Date.now());
  const navigate = useNavigate();

  useEffect(() => {
    const now = Date.now();
    
    // Reset counter if window has passed
    if (now - lastReset > windowMs) {
      setRequestCount(0);
      setLastReset(now);
    }
    
    // Increment request count
    setRequestCount(prev => prev + 1);
    
    // Check if rate limit exceeded
    if (requestCount >= maxRequests) {
      // Minimal production-only client error reporter
      (async () => {
        try {
          if (process.env.NODE_ENV !== 'production') return;
          await fetch('/api/client-logs', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ message: 'rate_limit_exceeded_admin_route', context: { location: window?.location?.pathname || '/' }, ts: Date.now() }),
            keepalive: true,
          });
        } catch (_) {}
      })();
      navigate('/unauthorized', { 
        state: { 
          message: 'Too many requests. Please wait before trying again.',
          code: 'RATE_LIMIT_EXCEEDED'
        }
      });
      return;
    }
  }, []);

  // If rate limit exceeded, don't render children
  if (requestCount >= maxRequests) {
    return null;
  }

  return children;
};

export default RateLimitedRoute;
